
export default {
  simplePlaceSearch: {
    noPlaceFound: 'Kein Ort mit diesen Angaben gefunden',
    openSidebarToSeeRouteDetails: 'Seitenleiste öffnen für Routen Infos',
    unknownSearchPlaceError: 'Unbekannter Fehler beim Suchen von Orten'
  }
}
